/** 页面列表：切换 / 新增 / 复制 / 删除 / 上下移动。 */
import { Button, Space, Tooltip, Popconfirm } from 'antd';
import { PlusOutlined, CopyOutlined, DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { useEditorStore } from '../store/store';

export function PagesTab() {
  const pages = useEditorStore((s) => s.doc.pages);
  const currentPageId = useEditorStore((s) => s.ui.currentPageId);
  const { setCurrentPage, addPage, duplicatePage, removePage, movePage } = useEditorStore.getState();

  return (
    <div style={{ padding: 8 }}>
      {pages.map((p, i) => {
        const active = p.id === currentPageId;
        return (
          <div
            key={p.id}
            onClick={() => setCurrentPage(p.id)}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', marginBottom: 6, borderRadius: 6, cursor: 'pointer',
              border: `1px solid ${active ? '#1677ff' : '#f0f0f0'}`, background: active ? '#e6f4ff' : '#fff',
            }}
          >
            <span style={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              <span style={{ color: '#999', marginRight: 6 }}>{i + 1}</span>{p.name || `第 ${i + 1} 页`}
              <span style={{ color: '#bbb', marginLeft: 6, fontSize: 11 }}>{p.layers.length} 层</span>
            </span>
            <Space size={0} onClick={(e) => e.stopPropagation()}>
              <Tooltip title="上移"><Button size="small" type="text" icon={<ArrowUpOutlined />} disabled={i === 0} onClick={() => movePage(i, i - 1)} /></Tooltip>
              <Tooltip title="下移"><Button size="small" type="text" icon={<ArrowDownOutlined />} disabled={i === pages.length - 1} onClick={() => movePage(i, i + 1)} /></Tooltip>
              <Tooltip title="复制"><Button size="small" type="text" icon={<CopyOutlined />} onClick={() => duplicatePage(p.id)} /></Tooltip>
              <Popconfirm title="删除该页？" onConfirm={() => removePage(p.id)} disabled={pages.length <= 1}>
                <Button size="small" type="text" danger icon={<DeleteOutlined />} disabled={pages.length <= 1} />
              </Popconfirm>
            </Space>
          </div>
        );
      })}
      <Button block icon={<PlusOutlined />} onClick={() => addPage()}>新增页面</Button>
    </div>
  );
}
